<article fxFlex="1 1 auto">
    <ng-content></ng-content>
</article>
<app-footer [ngClass]="{'login-footer' : haveLoginFooter}" *ngIf="!hideFooter" fxFlex="1 1 auto"></app-footer>
